import { render, staticRenderFns } from "./ProveedorForm.vue?vue&type=template&id=050eec1c&"
import script from "./ProveedorForm.vue?vue&type=script&lang=js&"
export * from "./ProveedorForm.vue?vue&type=script&lang=js&"
import style0 from "./ProveedorForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports